import { useUserSession } from '../../models/hooks/appStateHooks';
import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { LevStandardQueryMeta } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'board/id/items';

export function useGetOpportunity({ opportunityId, enabled = true }: { opportunityId: string; enabled?: boolean }) {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		meta: {
			errorLogging: { action: 'GetOpportunity-Error', category: 'Opportunities' },
		} satisfies LevStandardQueryMeta,
		queryFn: async () => {
			const result = await userSession.webServiceHelper.callAsync<Api.IOpportunity>(
				`board/item/${opportunityId}`,
				'GET'
			);
			return result;
		},
		queryKey: [BASE_QUERY_KEY, opportunityId],
		refetchOnWindowFocus: false,
	});
}
